import { Group, ContainerConfig } from "konva/lib/Core";
import { Rect, RectConfig } from "konva/lib/shapes/Rect";
import { Text } from "konva/lib/shapes/Text";
import { TextConfig } from "konva/types/shapes/Text";
import { ClicksCount, ReactionStatus, ReactionWrapperColor } from "./reactions";
import { isSafari } from "@gtmhub/whiteboards/rendering/util";

export enum ContainerSize {
  WIDTH = 24,
  HEIGHT = 24,
}

export enum IconSize {
  WIDTH = 16,
  HEIGHT = 16,
}

export enum ContainerType {
  Group,
  Wrapper,
}

export enum Emoji {
  FONT_FAMILY = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif',
  FONT_SIZE = 16,
  FONT_SIZE_SAFARI = 13,
  LINE_HEIGHT = 1,
  LINE_HEIGHT_SAFARI = 1.3,
}

export const CORNER_RADIUS = 20;
export const CONTAINER_BACKGROUND = "#F1F3F8";

export function newContainer(containerConfig?: Partial<RectConfig | ContainerConfig>, containerType: ContainerType = ContainerType.Wrapper): Rect | Group {
  const defaultContainer = {
    name: "container",
    x: 0,
    y: 0,
    width: ContainerSize.WIDTH,
    height: ContainerSize.HEIGHT,
    cornerRadius: CORNER_RADIUS,
    fill: CONTAINER_BACKGROUND,
  };

  const container = { ...defaultContainer, ...containerConfig };

  if (containerType === ContainerType.Wrapper) {
    return new Rect(container);
  } else {
    return new Group(container);
  }
}

export function newEmoji(textConfig?: TextConfig): Text {
  const defaultText = {
    name: "voting-action voting",
    fontFamiliy: Emoji.FONT_FAMILY,
    fontSize: Emoji.FONT_SIZE as number,
    lineHeight: Emoji.LINE_HEIGHT as number,
  };

  if (isSafari()) {
    defaultText.fontSize = Emoji.FONT_SIZE_SAFARI as number;
    defaultText.lineHeight = Emoji.LINE_HEIGHT_SAFARI as number;
  }

  const config = { ...defaultText, ...textConfig };

  return new Text(config);
}

export const reactionWrapperColor: { [key in ReactionStatus]: ReactionWrapperColor } = {
  [ReactionStatus.DEFAULT]: {
    fill: "#F1F3F8",
    stroke: "#F1F3F8",
  },
  [ReactionStatus.ACTIVE]: {
    fill: "#E5F2FF",
    stroke: "#AED2FE",
  },
  [ReactionStatus.DISABLED]: {
    fill: "#C0CBDD",
    stroke: "#C0CBDD",
  },
};

export const reactionWrapperHoveredColor: { [key in ReactionStatus]: ReactionWrapperColor } = {
  [ReactionStatus.DEFAULT]: {
    fill: "#E5F2FF",
    stroke: "#AED2FE",
  },
  [ReactionStatus.ACTIVE]: {
    fill: "#E5F2FF",
    stroke: "#75A2F7",
  },
  [ReactionStatus.DISABLED]: {
    fill: "#C0CBDD",
    stroke: "#C0CBDD",
  },
};

export const getReactionWrapperColorBasedOnStatus = (status: ReactionStatus, isHovered = false): ReactionWrapperColor => {
  return isHovered ? reactionWrapperHoveredColor[status] : reactionWrapperColor[status];
};

export const getReactionCountColorBasedOnStatus = (status: ReactionStatus): string => {
  return (status === ReactionStatus.ACTIVE || status === ReactionStatus.DEFAULT ? ClicksCount.ENABLED_COLOR : ClicksCount.DISABLED_COLOR) as string;
};
